import { createPinia } from 'pinia';
import apiFetch from '@/apiClient';

const pinia = createPinia();

export default pinia;

export const actions = {
  async fetchVisitors({ commit }) {
    try {
      const visitors = await apiFetch('/visitors');
      commit('SET_VISITORS', visitors);
    } catch (error) {
      console.error('Erreur lors de la récupération des visiteurs:', error.message);
    }
  },
};
